export const justThrow = <A>(a: A) => {
  throw a
}
